import { Order } from "@/types/orders";
export const isMobile = ():boolean => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const formatRuPhoneNumber = (num: number | string): string => {
    if (!num || num === undefined) return "Не указан";
    const str = num.toString();
    const prefix = str.slice(0, 1);
    const first = str.slice(1, 4);
    const second = str.slice(4, 7);
    const third = str.slice(7, 9);
    const fourth = str.slice(9, 11);
    return `+${prefix} (${first}) ${second}-${third}-${fourth}`;
  };
  export const formatRuPhoneNumberdigits = (num: number | string): string => {
    if (!num || num === undefined) return "Не указан";
    const str = num.toString();
    const prefix = str.slice(0, 1);
    const first = str.slice(1, 4);
    const second = str.slice(4, 7);
    const third = str.slice(7, 9);
    const fourth = str.slice(9, 11);
    return `${prefix} ${first} ${second} ${third} ${fourth}`;
  };


  export const formatTimeHHMM = (time: string) => {
    const [hours, minutes] = time.split(":").map(Number);
    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`
}
 // mark order as locked
export const orderIsLocked = (order: Order):boolean => {
    return (order.status in ["paid", "working", "completed"]);
  }

export const formatRuDate = (date: Date) => {
    const options:any = {
      weekday: "short",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    };
    return new Date(date).toLocaleString("ru", options);
  };

export const getFilenameFromContentDisposition = (disposition?: string | null): string | null => {
  if (!disposition) return null;
  const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1]);
    } catch {
      return utf8Match[1];
    }
  }
  const match = disposition.match(/filename="?([^";]+)"?/i);
  return match ? match[1] : null;
};

export const downloadBlob = (data: BlobPart, filename: string, type = "text/csv;charset=utf-8"): void => {
  const blob = new Blob([data], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const debounce = (
  func: (...args: unknown[]) => unknown,
  wait: number,
  immediate = false,
) => {
  let timeout: ReturnType<typeof setTimeout> | null = null;

  return function executedFunction(...args: unknown[]) {
    const later = () => {
      timeout = null;
      if (!immediate) func(...args);
    };

    const callNow = immediate && timeout === null;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) func(...args);
  };
}

/** Проверяет, что дата задана и находится в будущем (например, блокировка приёма заказов). */
export const isFutureDate = (date?: string | null): boolean => {
    if (!date) return false;
    const time = new Date(date).getTime();
    return !Number.isNaN(time) && time > Date.now();
};

/** Короткий формат даты и времени для компактных подписей (например, «21 окт., 18:00»). */
export const formatRuShortDateTime = (date?: string | null): string => {
    if (!date) return "";
    const parsed = new Date(date);
    if (Number.isNaN(parsed.getTime())) return "";
    const options: Intl.DateTimeFormatOptions = {
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
    };
    return parsed.toLocaleString("ru", options);
};

/** Оставляет в номере только цифры — так телефон уходит в API и правится в поле формы. */
export const toPhoneDigits = (value?: string | number | null): string => {
    if (value === null || value === undefined) return "";
    return String(value).replace(/\D/g, "");
};

/** Склонение существительного по числу: pluralizeRu(2, "день", "дня", "дней") → «дня». */
const pluralizeRu = (
    value: number,
    one: string,
    few: string,
    many: string,
): string => {
    const mod10 = value % 10;
    const mod100 = value % 100;
    if (mod10 === 1 && mod100 !== 11) return one;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few;
    return many;
};

/**
 * Остаток времени до даты в человекочитаемом виде: «через 2 ч 15 мин»,
 * «через 3 дня», «истекла». Для блокировки приёма заказов.
 */
export const formatRuRelativeUntil = (date?: string | null): string => {
    if (!date) return "";
    const time = new Date(date).getTime();
    if (Number.isNaN(time)) return "";
    const diffMinutes = Math.round((time - Date.now()) / 60000);
    if (diffMinutes <= 0) return "истекла";
    const days = Math.floor(diffMinutes / (60 * 24));
    const hours = Math.floor((diffMinutes % (60 * 24)) / 60);
    const minutes = diffMinutes % 60;
    if (days > 0) {
        const parts = [`${days} ${pluralizeRu(days, "день", "дня", "дней")}`];
        if (hours > 0) parts.push(`${hours} ч`);
        return `через ${parts.join(" ")}`;
    }
    if (hours > 0) {
        const parts = [`${hours} ч`];
        if (minutes > 0) parts.push(`${minutes} мин`);
        return `через ${parts.join(" ")}`;
    }
    return `через ${minutes} мин`;
};

